/*
 * @FilePath     : /es-package/packages/es-mpx-creator/lib/createApp.js
 * @Author       : LiYang
 * @Date         : 2021-08-12 18:50:57
 * @LastEditTime : 2022-01-04 15:54:43
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { mpx } from './index'
import {pipe} from '@didi/es-mpx-shared'
import apiProxy from '@mpxjs/api-proxy'


mpx.use(apiProxy, { usePromise: true })
function installPlugin (option) {
  if (!Array.isArray(option.plugins)) {
    return option
  }
  option.plugins.forEach(plugin => {
    if (typeof plugin === 'function') {
      plugin(mpx)
    }
  })

  delete option.plugins
  return option
}

export default pipe(installPlugin, mpx.createApp)